// src/components/sectionsData.js

import {
    faNetworkWired,
    faChartBar,
    faChartLine,
    faHeart,
    faCoins,
    faClock,
    faChalkboardTeacher,
    faServer,
    faShieldAlt,
    faKey,
    faUsers,
    faLightbulb,
    faBriefcase,
    faPlane,
    faDesktop,
    faBuilding,
    faMoneyBillTransfer,
    faWifi,
    faSitemap,
    faGaugeHigh,
    faCartShopping
    } from '@fortawesome/free-solid-svg-icons';

  // Export an array of section objects
  export const sectionsData = [
    {
      title: 'Axillon',
      color: 'primary',
      links: [
        {
          label: 'Axillon App Dashboard',
          icon: faGaugeHigh,
          url: 'https://axillon-app.axillonaerospace.com/dashboard/',
          requiresVpn: true,
          description: 'Axillon internal applications dashboard (VPN required).',
        },
        {
          label: 'Axillon Shop',
          icon: faCartShopping,
          url: 'https://axillonaerospace.shop/',
          requiresVpn: false,
          description: 'Shop Axillon Aerospace branded apparel and merchandise.',
        },
      ],
    },
    {
      title: 'HR, Benefits & Workplace',
      color: 'primary',
      links: [
        {
          label: 'Benefits Portal',
          icon: faHeart,
          url: 'https://carbontopco.bswift.com/',
          requiresVpn: false,
          description: 'View and manage your employee benefits here.',
        },
        {
          label: 'UKG Pro',
          icon: faUsers,
          url: 'https://skcappartners.ukg.net',
          requiresVpn: false,
          description: 'Access HR information, payroll, and time off requests.',
        },
        {
          label: 'Recruiting',
          icon: faBriefcase,
          url: 'https://axillonaerospace-openhire.silkroad.com/',
          requiresVpn: false,
          description: 'Our applicant tracking system for job postings and hires.',
        },
        {
          label: 'Envoy',
          icon: faBuilding,
          url: 'https://dashboard.envoy.com/login',
          requiresVpn: false,
          description: 'Manage workplace visitor access and office reservations.',
        },
        {
          label: 'Org Chart',
          icon: faSitemap,
          url: 'https://na2.theorgchart.com/serverside/api/secureopenchart?dl=dXNlcj1yZXN0cmljdGVkJTQwYXhpbGxvbmFlcm9zcGFjZS5jb20mb3JnPWF4aWxsb25hZXJvc3BhY2UmbW9kZT1jaGFydCZjaGFydElEPTAmbGF1bmNocHJvZmlsZT1SZXN0cmljdGVkJmNyYz0tNDc4MDc2MzE',
          requiresVpn: false,
          description: 'View the company organizational chart.',
        },
      ],
    },
    {
      title: 'Travel',
      color: 'primary',
      links: [
        {
          label: 'Travel Bank',
          icon: faMoneyBillTransfer,
          url: 'https://app.travelbank.com/user/login?active=email',
          requiresVpn: false,
          description: 'Track business travel expenses.',
        },
        {
          label: 'I Want My Travel',
          icon: faPlane,
          url: 'https://wx1.getthere.net/logininq.act?&site=iwantmytravelmain&watermark=1&siteID=8106296&transIndex=0%3A2.0.0.0%3A2&sid=582&token=b2b4426e3a94387ad880ebc1829c49f4',
          requiresVpn: false,
          description: 'Corporate travel booking and management portal.',
        },
      ],
    },
    {
      title: 'Analytics',
      color: 'primary',
      links: [
        {
          label: 'Tableau (Analytics)',
          icon: faChartBar,
          url: 'https://ca1svr-tab01.axillonaerospace.com/#/home',
          requiresVpn: true,
          description: 'Analytics dashboards (VPN required).',
        },
        {
          label: 'Power BI (Analytics)',
          icon: faChartBar,
          url: 'https://app.powerbi.com/home',
          requiresVpn: false,
          description: 'Analytics dashboards',
        },
        {
          label: 'Planning Analytics',
          icon: faChartBar,
          url: 'https://westus3.planninganalytics.saas.ibm.com/',
          requiresVpn: false,
          description: 'IBM Planning Analytics for budgeting, forecasting, and reporting.',
        },
        {
          label: 'SPC',
          icon: faChartLine,
          url: 'http://ca1svr-scada01:8088/data/perspective/client/AX_SPC/',
          requiresVpn: true,
          description: 'Statistical Process Control (Ignition Perspective).',
        },
        {
          label: 'Foresight Advanced Analytics',
          icon: faChartBar,
          url: 'https://axillon-app.axillonaerospace.com/spc/',
          requiresVpn: true,
          description: 'Foresight advanced analytics for SPC and process insights.',
        },
      ],
    },
    {
      title: 'Sales & Finance',
      color: 'primary',
      links: [
        {
          label: 'CRM (Dynamics 365)',
          icon: faUsers,
          url: 'https://axillon.crm.dynamics.com',
          requiresVpn: false,
          description: 'Customer relationship management (Dynamics 365).',
        },
        {
          label: 'JP Morgan File Transfer',
          icon: faMoneyBillTransfer,
          url: 'https://ftscata.mfts.jpmchase.com',
          requiresVpn: false,
          description: 'JP Morgan Chase - SFTP File Transfer',
        },
      ],
    },
    {
      title: 'Compliance & Security',
      color: 'primary',
      links: [
        {
          label: 'VelocityEHS',
          icon: faBuilding,
          url: 'https://axillon.kminnovations.net/Apps/Login/UserLogin.aspx',
          requiresVpn: false,
          description: 'Safety & environmental management portal.',
        },
        {
          label: 'Ethics & Compliance (EthicsPoint)',
          icon: faShieldAlt,
          url: 'https://axillonaerospace.ethicspoint.com',
          requiresVpn: false,
          description: 'Submit or follow up on ethics and compliance reports.',
        },
        {
          label: 'Secure Transfer (Kiteworks)',
          icon: faKey,
          url: 'https://axtransfer.kiteworks.com/#/mail/inbox',
          requiresVpn: false,
          description: 'Access secure file transfer via Kiteworks.',
        },
      ],
    },
    {
      title: 'Support',
      color: 'primary',
      links: [
        {
          label: 'IT Support',
          icon: faDesktop,
          url: 'https://axillon.atlassian.net/servicedesk/customer/portal/1',
          requiresVpn: false,
          description: 'IT support ticketing system.',
        },
      ],
    },
    {
      title: 'Baltimore',
      color: 'primary',
      links: [
        {
        label: 'Baltimore Intranet',
        icon: faChartBar,
        url: 'http://it-manager/intranet/Site/view.cfm?siteID=1',
        requiresVpn: true,
        description: 'Baltimore Intranet requires access to Baltimore network',
      }
      ]
    },
    {
      title: 'Rockmart',
      color: 'primary',
      links: [
        {
          label: 'Data Analytics',
          icon: faChartBar,
          url: 'https://parkercorp.sharepoint.com/sites/Meggitt_RockmartDataAnalytics',
          requiresVpn: false,
          description: 'SharePoint analytics.',
        },
        {
          label: 'LOA/FMLA link',
          icon: faCoins,
          url: 'https://www.lincolnfinancial.com/',
          requiresVpn: false,
          description: 'Lincoln Financial portal for LOA / FMLA details.',
        },
        {
          label: 'Timekeeping',
          icon: faClock,
          url: 'https://meggittusa.prd.mykronos.com',
          requiresVpn: false,
          description: 'Punch in/out and manage work hours.',
        },
        {
          label: 'Training Portal',
          icon: faChalkboardTeacher,
          url: 'https://meggitt-8585.reach360.com/learn/',
          requiresVpn: false,
          description: 'Online training courses.',
        },
      ],
    },
    {
      title: 'San Diego',
      color: 'primary',
      links: [
        {
          label: 'SCADA System',
          icon: faNetworkWired,
          url: 'http://usbipvscada01.corp.axillonaerospace.com::8090/',
          requiresVpn: true,
          description: 'System Control and Data Acquisition (VPN required).',
        },
        {
          label: 'Continuous Improvement',
          icon: faChartLine,
          url: 'https://axillon.atlassian.net/jira/core/projects/CI2/board',
          requiresVpn: false,
          description: 'Submit or view ongoing improvement initiatives.',
        },
        {
          label: 'Submit a bright idea',
          icon: faLightbulb,
          url: 'http://usbipvpython.corp.axillonaerospace.com::2005/',
          requiresVpn: true,
          description: 'Innovation portal to share new ideas (VPN required).',
        },
        {
          label: 'Timekeeping',
          icon: faClock,
          url: 'http://usbipvm2msfdc.corp.axillonaerospace.com:8080/unanet/action/home',
          requiresVpn: true,
          description: 'Unanet system for managing project hours (VPN required).',
        },
        {
          label: 'Doc Control & Training',
          icon: faChalkboardTeacher,
          url: 'http://ca1svr-mcapp02.corp.axillonaerospace.com:/mc/login/index.cfm?action=displayLoginPage',
          requiresVpn: true,
          description: 'Document control and employee training system (VPN required).',
        },
        {
          label: 'Facilities Support',
          icon: faBuilding,
          url: 'https://x34.emaint.com/',
          requiresVpn: false,
          description: 'Comprehensive maintenance management system to request facilities supports',
        },
      ],
    },
    {
      title: 'IT',
      color: 'primary',
      links: [
        {
          label: 'San Diego Vsphere',
          icon: faServer,
          url: 'https://usbipvcsa70.corp.axillonaerospace.com/',
          requiresVpn: true,
          description: 'Manage the San Diego virtual environment (VPN required).',
        },
        {
          label: 'Saltillo Vsphere',
          icon: faServer,
          url: 'https://mxaipvvcsa01.corp.axillonaerospace.com/',
          requiresVpn: true,
          description: 'Manage the Saltillo virtual environment (VPN required).',
        },
        {
          label: 'Rockmart Vsphere',
          icon: faServer,
          url: 'https://cfc311vc100.efclocal.com/',
          requiresVpn: true,
          description: 'Manage the Rockmart virtual environment (VPN required).',
        },
        {
          label: 'Erlanger Vsphere',
          icon: faServer,
          url: 'https://uscipvcsa01.corp.axillonaerospace.com/',
          requiresVpn: true,
          description: 'Manage the Erlanger virtual environment (VPN required).',
        },
        {
          label: 'Baltimore Vsphere',
          icon: faServer,
          url: 'https://10.99.95.216/',
          requiresVpn: true,
          description: 'Manage the Baltimore virtual environment (VPN required).',
        },
        {
          label: 'Lumen',
          icon: faWifi,
          url: 'https://controlcenter.lumen.com/enterprise/dashboard',
          requiresVpn: false,
          description: 'Lumen control center for network management',
        },
        {
          label: 'Snowflake Analytics',
          icon: faChartBar,
          url: 'https://app.snowflake.com/mkfbiyg/wz93475/#/homepage',
          requiresVpn: false,
          description: 'Cloud-based data warehouse and analytics platform.',
        },
        {
        label: 'Network SolarWinds (Orion)',
        icon: faNetworkWired,
        url: 'https://ca1svr-solwind1.corp.axillonaerospace.com/Orion/SummaryView.aspx?ViewID=1',
        requiresVpn: true,
        description: 'Monitor and analyze network performance (Orion).',
      },
      {
        label: 'SolarWinds Customer Portal',
        icon: faShieldAlt,
        url: 'https://customerportal.solarwinds.com/settings/company-admin',
        requiresVpn: false,
        description: 'Licensing, downloads, and portal administration.',
      },
      {
        label: 'Fortinet Support',
        icon: faNetworkWired,
        url: 'https://support.fortinet.com/welcome/#/',
        requiresVpn: false,
        description: 'Fortinet support portal for security and network management.',
      },
      {
        label: 'Microsoft Admin Center',
        icon: faUsers,
        url: 'https://admin.microsoft.com/adminportal/home#/users',
        requiresVpn: false,
        description: 'Manage Microsoft 365 users, licenses, and tenant settings.',
      },
      ],
    },
  ];
